import { faArrowLeft, faExclamationCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { API } from '../api/api';
import FindPriceLocation from '../components/chart/FindPriceLocation';
import FindPriceUnitCondition from '../components/chart/FindPriceUnitCondition';
import LoginModal from '../components/LoginModal';
import Sidebar from '../components/Sidebar';
import TopNav from '../components/TopNav';
import $ from 'jquery';
import FindPriceTypePerYear from '../components/chart/FindPriceTypePerYear';
import FindPriceByTime from '../components/chart/FindPriceByTime';
import Line from '../components/Line';
import { viewDetailByLocation, viewDetailByTime } from '../services/amplitude';

const PopularOverview = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { state } = useLocation();

  const { brand, type, cylinder, year } = useSelector((state) => state.checkPriceReducer.selected_cari_harga);
  const selectedSeries = useSelector((state) => state.checkPriceReducer.selected_cari_harga.series);

  const onLoginModal = (section) => {
    $('#modal-login').modal('toggle');

    const data = {
      item_brand: brand,
      item_series: selectedSeries,
      item_type: type,
      item_cylinder: cylinder,
      item_year: year,
    };

    section === 'location' ? viewDetailByLocation(data) : viewDetailByTime(data);
  };

  const [loggedIn, setLoggedIn] = useState(false);

  const colors = ['#f0a18c', '#f05377', '#b85382', '#564887', '#074c89'];
  const regions = [
    'id-indo',
    'id-aceh',
    'id-kaltim',
    'SEMARANG',
    'id-bengkulu',
    'BANTEN',
    'id-kalbar',
    'id-belitung',
    'BALI',
    'SURABAYA',
    'id-kalsel',
    'id-ntt',
    'MAKASSAR',
    'id-kriau',
    'id-irian',
    'MEDAN',
    'PEKANBARU',
    'id-sulut',
    'id-malut',
    'id-sumbar',
    'id-maluku',
    'id-ntb',
    'id-sultra',
    'id-sulteng',
    'id-papua',
    'BANDUNG',
    'LAMPUNG',
    'JAKARTA',
    'id-gorontalo',
    'id-yogya',
    'id-kalteng',
    'PALEMBANG',
    'id-sulbar',
    'JAMBI',
  ];

  let chart1 = { series: [], title: '' };
  let chart2 = { series: [], title: '' };
  let chart3 = { series: [], title: '' };
  let chart4 = { series: [], title: '' };

  let variants = null;

  let series1 = null;
  let series2 = null;
  let series3 = null;
  let series4 = null;

  const grades = ['A', 'B', 'C', 'D', 'E'];
  const [isRequesting, setIsRequesting] = useState({
    isRequesting1: true,
    isRequesting2: true,
    isRequesting3: true,
    isRequesting4: true,
  });

  const [variant, setVariant] = useState(null);
  const [series, setSeries] = useState({
    series1: null,
    series2: null,
    series3: null,
    series4: null,
  });

  const getData = (selected) => {
    setIsRequesting({
      isRequesting1: true,
      isRequesting2: true,
      isRequesting3: true,
      isRequesting4: true,
    });

    dispatch({ type: 'SET_SELECTED_CARI_HARGA', value: selected });

    Promise.all([
      Axios.get(API.service.unit_condition, { params: state })
        .then((res) => {
          const data = res.data.data;

          series1 =
            data.item.length > 0
              ? [
                  {
                    name: data.title,
                    data: grades.map((grade, i) => {
                      const { hargaTerendah, hargaTertinggi } = data.item.find((e) => e.grade === grade) || {
                        hargaTerendah: null,
                        hargaTertinggi: null,
                      };
                      return {
                        color: colors[i],
                        low: hargaTerendah != null ? parseInt(hargaTerendah) : null,
                        high: hargaTertinggi != null ? parseInt(hargaTertinggi) : null,
                      };
                    }),
                    minPointLength: 5,
                  },
                ]
              : null;

          chart1.series = series1;
          chart1.title = data.title;
        })
        .catch((err) => {}),

      Axios.get(API.service.type_of_year, { params: state })
        .then((res) => {
          const data = res.data.data;
          series2 =
            data.item.length > 0
              ? data.item.map(({ year, price }, i) => ({
                  name: year,
                  color: colors[i],
                  minPointLength: 5,
                  data: grades.map((masuk) => {
                    if (typeof price !== 'undefined') {
                      const rawData = price.find((obj) => obj.grade === masuk) || {
                        grade: masuk,
                        hargaTerendah: '-',
                        hargaTertinggi: '-',
                      };
                      return {
                        year: year,
                        low: parseInt(rawData.hargaTerendah),
                        high: parseInt(rawData.hargaTertinggi),
                      };
                    } else {
                      return {
                        low: '-',
                        high: '-',
                      };
                    }
                  }),
                }))
              : null;

          chart2.series = series2;
          chart2.title = data.title;
        })
        .catch((err) => {}),

      Axios.get(API.service.area_city, { params: state })
        .then((res) => {
          const data = res.data.data;

          series3 =
            data.item.length > 0
              ? regions.map((region) => {
                  const { hargaTerendah, hargaTertinggi } = data.item.find((e) => e.lokasi == region) || {
                    hargaTerendah: null,
                    hargaTertinggi: null,
                  };
                  return {
                    'hc-key': region,
                    value: hargaTertinggi ? parseInt(hargaTertinggi) : null,
                    valueMin: hargaTerendah ? parseInt(hargaTerendah) : null,
                  };
                })
              : null;

          chart3.series = series3;
          chart3.title = data.title;
        })
        .catch((err) => {}),

      Axios.get(API.service.time, { params: state })
        .then((res) => {
          const data = res.data.data;

          series4 =
            data.item.length > 0
              ? grades.map((grade, i) => {
                  const { price } = data.item.find((e) => e.grade === grade) || { price: [].fill(null, 0, 5) };
                  return {
                    name: `Grade ${grade}`,
                    data: price.map((p) => (p > 0 ? parseInt(p) : null)),
                    color: colors[i],
                  };
                })
              : null;

          chart4.series = series4;
          chart4.title = data.title;
        })
        .catch((err) => {}),
    ]).then((values) => {
      dispatch({
        type: 'SET_CHART',
        value: {
          chart1: chart1,
          chart2: chart2,
          chart3: chart3,
          chart4: chart4,
        },
      });

      setVariant(variants);

      setSeries({
        series1: series1,
        series2: series2,
        series3: series3,
        series4: series4,
      });

      setIsRequesting({
        isRequesting1: false,
        isRequesting2: false,
        isRequesting3: false,
        isRequesting4: false,
      });
    });
  };

  useEffect(() => {
    if (localStorage.getItem('id') != null) {
      setLoggedIn(true);
    }

    getData(state);
  }, []);

  const noData = () => {
    return (
      <div className="col-xl-12 text-center py-2">
        <p>
          <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 25, color: '#777777' }} />
        </p>
        <span style={{ color: '#777777', fontSize: 16 }}>Data Tidak Ditemukan !</span>
      </div>
    );
  };

  return (
    <>
      <LoginModal pageChannel="Overview" />
      <div className="findprice-page">
        <TopNav pageChannel="Overview" />
        <div className="container-fluid main-findprice">
          <div className="row h-100">
            <Sidebar pageChannel="Overview" />
            <div className="col-xl-10 col-lg-12 pt-3 content">
              <div className="container-fluid mt-3 card shadow-sm">
                <div className="row">
                  <div className="col-12 py-5">
                    <div className="row d-lg-flex align-items-lg-center align-items-md-start">
                      {!isRequesting.isRequesting1 ? (
                        <FindPriceUnitCondition />
                      ) : (
                        <div className="col-xl-12 text-center">
                          <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid mt-3 card shadow-sm">
                <div className="row">
                  <div className="col-md-12 py-5">
                    <div className="row d-lg-flex align-items-lg-center align-items-md-start">
                      {isRequesting.isRequesting2 && (
                        <div className="col-xl-12 text-center">
                          <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                        </div>
                      )}
                      {!isRequesting.isRequesting2 && <FindPriceTypePerYear />}
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid mt-3 card shadow-sm">
                <div className="row">
                  <div className="col-md-12 py-5">
                    <div className="row d-lg-flex align-items-lg-center align-items-md-start">
                      {isRequesting.isRequesting3 && (
                        <div className="col-xl-12 text-center">
                          <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                        </div>
                      )}
                      {!isRequesting.isRequesting3 && <FindPriceLocation />}
                    </div>
                  </div>
                  {!isRequesting.isRequesting3 && !loggedIn && (
                    <div className="card-blocked">
                      <h4>Silahkan Masuk Untuk Melihat Data Ini</h4>
                      <button onClick={() => onLoginModal('location')} className="btn mt-5 w-15">
                        Masuk
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="container-fluid mt-3 card shadow-sm">
                <div className="row">
                  <div className="col-md-12 py-5">
                    <div className="row d-lg-flex align-items-lg-center align-items-md-start">
                      {isRequesting.isRequesting4 && (
                        <div className="col-xl-12 text-center">
                          <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                        </div>
                      )}
                      {!isRequesting.isRequesting4 && <FindPriceByTime />}
                    </div>
                  </div>
                  {!isRequesting.isRequesting4 && !loggedIn && (
                    <div className="card-blocked">
                      <h4>Silahkan Masuk Untuk Melihat Data Ini</h4>
                      <button onClick={() => onLoginModal('time')} className="btn mt-5 w-15">
                        Masuk
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="findprice-page-mobile">
        <div className="container-fluid">
          <div className="row bg-light">
            <div className="col-12 pt-3 pb-2 d-flex px-4 align-items-center header">
              <FontAwesomeIcon
                onClick={() => {
                  history.replace({
                    pathname: '/',
                    state: {
                      pageChannel: 'Overview',
                    },
                  });
                }}
                className="mb-2"
                icon={faArrowLeft}
              />
              <h4 className="ml-3" style={{ fontSize: '1.5rem' }}>
                Pencarian Populer:
              </h4>
            </div>
          </div>
          <div className="row mt-4 bg-light">
            <div className="col-12 py-2">
              {!isRequesting.isRequesting1 ? (
                <FindPriceUnitCondition />
              ) : (
                <div className="col-12 text-center py-3 spinner-container">
                  <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                </div>
              )}
            </div>
          </div>
          <div className="row mt-4 bg-light">
            <div className="col-12 py-2">
              {isRequesting.isRequesting2 && (
                <div className="col-12 text-center py-3 spinner-container">
                  <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                </div>
              )}
              {!isRequesting.isRequesting2 && <FindPriceTypePerYear />}
            </div>
          </div>
          <div className="row mt-4 bg-light position-relative">
            <div className="col-12 py-2">
              {isRequesting.isRequesting3 && (
                <div className="col-12 text-center py-3 spinner-container">
                  <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                </div>
              )}
              {!isRequesting.isRequesting3 && <FindPriceLocation />}
            </div>
            {!isRequesting.isRequesting3 && !loggedIn && (
              <div className="card-blocked-mobile">
                <h4>Silahkan Masuk Untuk Melihat Data Ini</h4>
                <button onClick={() => onLoginModal('location')} className="btn mt-5 w-15">
                  Masuk
                </button>
              </div>
            )}
          </div>
          <div className="row mt-4 mb-4 bg-light" style={{ height: 'max-content', position: 'relative' }}>
            <div className="col-12 py-2">
              {isRequesting.isRequesting4 && (
                <div className="col-12 text-center py-3 spinner-container">
                  <FontAwesomeIcon spin={true} icon={faSpinner} style={{ fontSize: 40 }} />
                </div>
              )}
              {!isRequesting.isRequesting4 && <FindPriceByTime />}
            </div>
            {!isRequesting.isRequesting4 && !loggedIn && (
              <div className="card-blocked-mobile">
                <h4>Silahkan Masuk Untuk Melihat Data Ini</h4>
                <button onClick={() => onLoginModal('time')} className="btn mt-5 w-15">
                  Masuk
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PopularOverview;
